import React, { FC, useState } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Title } from '../developers/page-components/Title';
import { Table } from '../table/Table';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ConfigurationForm } from './ConfigurationForm';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useTranslation } from 'react-i18next';
import {
	fetchFundsReserveConfigActive,
	fetchFundsReserveConfigInactive,
} from '../../store/merchnts/actions/fundsReserveConfig';

export const ActiveReserveConfigurations: FC = () => {
	const { t } = useTranslation();

	const { merchantState: { fundsReserveConfigActiveListData, isFundsReserveConfigActiveListDataLoading, fundsReserveConfigLists }, dispatch } = useMerchants();

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const [configState, setConfigState] = useState({
		isOpen: false,
		configId: ''
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
	const closeConfigModal = (): void => setConfigState(({ isOpen: false, configId: '' }));

	const handleSuccess = (): void => {
		closeConfigModal();
		setModalState({
      isOpen: true,
      modalTitle: 'Refund information',
      content: (
        <div className="fs-6">
          Refund information was successfully saved!
        </div>
      ),
      confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
      minHeight: 100,
      onConfirm: async () => {
        closeModal();
        await fetchFundsReserveConfigActive(dispatch);
        await fetchFundsReserveConfigInactive(dispatch);
      },
      onClose: closeModal
    });
	};

	const handleError = (): void => {
		setConfigState(prev => ({ ...prev,isOpen: false }));
		setModalState({
      isOpen: true,
      modalTitle: 'Refund information',
      content: (
        <div className="fs-6 text-danger">
          Failed adding Refund information.
        </div>
      ),
      confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
      minHeight: 100,
      onConfirm: () => {
	      closeModal();
	      setConfigState(prev => ({ ...prev, isOpen: true }));
      },
      onClose: closeModal
    });
	};

	const rowActions = (rowData): JSX.Element => {
		return (
			<div
				className="text-center text-muted fs-7 fw-bolder cursor-pointer"
				onClick={(): void => setConfigState({
					isOpen: true,
					configId: rowData?.original?.id
        })}
			>
				Edit
			</div>
		);
	};

	return (
		<>
			<Table
				name={TablesNames.fundsReserveConfigActive}
				data={fundsReserveConfigActiveListData || []}
				isLoading={isFundsReserveConfigActiveListDataLoading}
				enableRowActions={true}
				rowActions={rowActions}
				positionActionsColumn='last'
				actionColumnsSize={50}
				toolbarCustomAction={
					<Title title='Active Configurations' additionalClass='fs-4 ms-2'/>
				}
			/>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

			<ModalWindow
				isOpen={configState?.isOpen}
				onClose={closeConfigModal}
				modalTitle="Edit"
				backdrop='static'
				content={<ConfigurationForm
					id={configState?.configId}
					closeModal={closeConfigModal}
					onSuccess={handleSuccess}
					onError={handleError}
				/>}
			/>
		</>
	);
};